import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getWishlist, removeWishlist } from "../services/wishlistService";
import ProductCardNew from "../components/ProductCard/ProductCardNew";
import { ChevronDown } from "lucide-react";
import noOrderImage from "../assets/images/fav.avif";
import DashboardProductsSkeleton from "./Dashboard/Skeleton/Products/DashboardProductsSkeleton.jsx";
export default function DashboardWishlist() {
  const { user } = useAuth();

  const [wishlist, setWishlist] = useState([]);
  const [visibleCount, setVisibleCount] = useState(12);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getWishlist().then((data) => {
      console.log(data);
      setWishlist(data);
      setLoading(false);
    });
  }, []);

  const showMore = () => {
    setVisibleCount((prev) => prev + 12);
  };

  const visibleProducts = wishlist.slice(0, visibleCount);

  const handleRemove = async (id) => {
    const success = await removeWishlist(id);

    if (!success) return;

    setWishlist((prev) => prev.filter((item) => item.id !== id));
  };

  useEffect(() => {
    const img = new Image();
    img.src = "/images/fav.avif";
  }, []);

  // if (loading) {
  //   return (
  //     <div className="loader-wrapper">
  //       <div className="loading">
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //       </div>
  //     </div>
  //   );
  // }

  
    if (loading) {
    return <DashboardProductsSkeleton productCount={8} />;
  }

  return (

    
    <div className="wrapper">

      
      <h2>
        <span> علاقه مندی های من</span>
      </h2>

      {wishlist.length === 0 ? (
        <div className="orderNone">
          <p>لیست علاقه مندی شما خالی است</p>
          <div>
            <img src={noOrderImage} alt="No active wishlist" />
          </div>
        </div>
      ) : (
        <div className="grid">
          {visibleProducts.map((p) => (
            <ProductCardNew key={p.id} product={p} />
          ))}
        </div>
      )}

      <div className="wrapper-footer">
        {wishlist.length > visibleCount && (
          <button onClick={showMore} className="show-more-btn">
            نمایش بیشتر
            <ChevronDown color="#95b73c" />
            {/* Show More ({wishlist.length - visibleCount} left) */}
          </button>
        )}
      </div>
    </div>
  );
}

// const styles = {
//   loaderWrapper: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     height: "60vh",
//   },
// };

// <div key={item.id} className="wishlist-card">
//   ID Wish: <p>{item.id}</p>
//   {/* <img src={item.product.image} width="80" alt="" /> */}
//   {/* <h4>{item.product.name}</h4> */}
//   {/* <p>${item.product.price}</p> */}
//   <button onClick={() => handleRemove(item.id)}>Remove</button>
// </div>
